/**
 * Bozze locali dei campi di testo (TEST-MATRIX X-03: dopo 10 minuti in background
 * il testo e ancora nel campo). Si salva a ogni battuta, non all'uscita: su mobile
 * il sistema puo chiudere la pagina senza avvisare.
 *
 * localStorage puo mancare o essere pieno (navigazione privata, quota): in quel caso
 * il campo continua a funzionare, semplicemente senza bozza.
 */
const PREFIX = 'mamma:bozza:'

export function readDraft(key: string): string {
  try {
    return window.localStorage.getItem(PREFIX + key) ?? ''
  } catch {
    return ''
  }
}

export function writeDraft(key: string, value: string): void {
  try {
    if (value === '') window.localStorage.removeItem(PREFIX + key)
    else window.localStorage.setItem(PREFIX + key, value)
  } catch {
    // Nessuna bozza possibile: il testo resta comunque nel campo finche la pagina vive.
  }
}

/** Da chiamare quando la risposta e stata salvata davvero dal server. */
export function clearDraft(key: string): void {
  writeDraft(key, '')
}
